app.controller('AccountPaymentController', ['$rootScope', '$scope', '$location', function ($rootScope, $scope, $location) {

    const siteHelper = $rootScope.site_helper;

    $scope.view_model = {
        is_all_statement_orders_selected: false,
        statement_orders: {},
        payment_on_account: 0,
        invoice_address: {},
        small_alerts: {},
        payment_options: [],
        payment_option_id: null,
        sagepay_create_token: false,
        have_statement_orders: false,
        confirm_delete_sagepay_token_id: null,
    }

    const viewModel = $scope.view_model;

    $rootScope.service.account.requireMinimumData(function () {
        if ($rootScope.model.staff.is_staff_or_rep || !$rootScope.model.account.customer_data) {
            return;
        }
        let statementOrders = {}
        let haveStatementOrders = false;
        if ($rootScope.model.account.customer_data.live_statement) {
            statementOrders = JSON.parse(JSON.stringify($rootScope.model.account.customer_data.live_statement))
            for (let statementOrderID in statementOrders) {
                const statementOrder = statementOrders[statementOrderID];
                statementOrder.is_selected = statementOrder.age >= 2;
                statementOrder.value = parseFloat(statementOrder.value)
                statementOrder.value_to_pay = statementOrder.value
                statementOrder.minimum_value = statementOrder.value < 0 ? statementOrder.value : 0
                haveStatementOrders = true;

            }
        }
        viewModel.statement_orders = statementOrders;
        viewModel.have_statement_orders = haveStatementOrders;
        populatePaymentOption();
    });

    function populatePaymentOption() {
        viewModel.payment_options.length = 0;
        const sagepayTokens = $rootScope.model.account.user_data.sagepay_tokens;
        let haveValidPaymentOptionID = viewModel.payment_option_id === "sagepay";
        if (sagepayTokens) {
            for (let sagepayTokenID in sagepayTokens) {
                if (sagepayTokenID === viewModel.payment_option_id) {
                    haveValidPaymentOptionID = true;
                }
                const sagepayToken = sagepayTokens[sagepayTokenID];
                viewModel.payment_options.push({
                    id: sagepayToken.id,
                    type: "sagepay",
                    sagepay_token: sagepayToken
                })
            }
        }
        viewModel.payment_options.push({
            id: "sagepay",
            type: "sagepay"
        })
        if (!haveValidPaymentOptionID) {
            viewModel.payment_option_id = null;
        }
        if (viewModel.payment_options.length === 1) {
            viewModel.payment_option_id = "sagepay";
        }
    }


    $scope.onAllStatementOrdersClick = function () {


        for (let statementOrderID in viewModel.statement_orders) {
            const statementOrder = viewModel.statement_orders[statementOrderID];
            statementOrder.is_selected = $scope.view_model.is_all_statement_orders_selected;
        }

    };

    $scope.onStatementSelectedChange = function () {
        let allSelected = true;
        for (let statementOrderID in viewModel.statement_orders) {
            const statementOrder = viewModel.statement_orders[statementOrderID];
            if (!statementOrder.is_selected) {
                allSelected = false;
                break
            }
        }
        $scope.view_model.is_all_statement_orders_selected = allSelected;
    }

    $scope.toggleStatementOrderSelected = function (statementOrderID) {
        const statementOrder = viewModel.statement_orders[statementOrderID];
        statementOrder.is_selected = !statementOrder.is_selected;
        $scope.onStatementSelectedChange();
    };


    $scope.getInvoiceAddress = function () {
        return viewModel.invoice_address;
    }

    $scope.getTotalValueToPay = function () {

        let statementOrderTotal = 0;

        for (let statementOrderID in viewModel.statement_orders) {
            const statementOrder = viewModel.statement_orders[statementOrderID];
            if (statementOrder.is_selected) {
                statementOrderTotal += statementOrder.value_to_pay;
            }
        }

        return statementOrderTotal + (viewModel.payment_on_account ? viewModel.payment_on_account : 0);
    };

    $scope.onPaymentOptionChange = function () {
        siteHelper.resetObject(viewModel.small_alerts);
    }

    $scope.makeAccountPayment = function (validateFormCallback) {

        siteHelper.resetObject(viewModel.small_alerts);

        const paymentLines = [];

        for (let statementOrderID in viewModel.statement_orders) {
            const statementOrder = viewModel.statement_orders[statementOrderID];
            if (statementOrder.is_selected) {
                paymentLines.push({
                    id: statementOrder.id,
                    type: statementOrder.type,
                    value: statementOrder.value_to_pay
                });
            }
        }
        if (viewModel.payment_on_account > 0) {
            paymentLines.push({
                id: "_unspecified",
                type: "unapplied_payment",
                value: viewModel.payment_on_account
            });
        }
        const totalValueToPay = $scope.getTotalValueToPay();


        if (paymentLines.length === 0 || totalValueToPay === 0) {
            validateFormCallback(false, siteHelper.addErrorMessage("You have not selected any invoices for payment."));
            return
        }

        const paymentData = {
            type: "accounts_payment",
            payment_on_account: viewModel.payment_on_account,
            lines: paymentLines,
            customer_code: $rootScope.service.account.getCustomerCode(),
            response_url: 'https://' + $location.host() + '/account/payments/processing/{ID}',
            make_account_payment: true,
            payment_type: "sagepay",
            invoice_address: viewModel.invoice_address,
            sagepay_create_token: viewModel.payment_option_id === "sagepay" ? viewModel.sagepay_create_token : false
        }

        if (viewModel.payment_option_id !== "sagepay") {
            paymentData.sagepay_token = viewModel.payment_option_id;
        }

        $rootScope.service.account.makeAccountPayment(paymentData, function (success, data, messages) {
            if (success) {
                window.location = data._redirect_url;
            }
            validateFormCallback(success, messages);
        });

    };

    $scope.deleteSagepayToken = function (sagepayTokenID) {
        const sagepayToken = $rootScope.model.account.user_data.sagepay_tokens[sagepayTokenID];
        if (!sagepayToken) {
            return;
        }

        $rootScope.service.account.deleteSagepayToken(sagepayTokenID, function (success, data, messages) {

            let paymentOptionAlerts;
            if (success) {
                paymentOptionAlerts = siteHelper.addSuccessMessage(
                    "Card Deleted: " + sagepayToken.card_type + " *" + sagepayToken.last_four_digits + " expires " + sagepayToken.expiry_date + " " + sagepayToken.id
                );
                viewModel.confirm_delete_sagepay_token_id = null;
            } else {
                paymentOptionAlerts = messages && messages.length > 0 ? messages : siteHelper.addErrorMessage(
                    "Unable to delete card"
                );
            }
            viewModel.small_alerts.payment_option = paymentOptionAlerts;
            populatePaymentOption();
        });
    };

}]);